import { CheckoutMapSettingsItem } from 'features/settings/components/ppoints/design-settings/CheckoutMapSettings/model/CheckoutMapSettings';
import httpApi from 'hooks/api/httpApi';

export const getCheckoutMapSettings = async (ecomId: number): Promise<CheckoutMapSettingsItem[]> => {
    const res = await httpApi.get<CheckoutMapSettingsItem[]>(`/api/ecom/${ecomId}/checkout/setting`);
    return res.getData();
};

export const postCheckoutMapSettings = async (ecomId: number, items: CheckoutMapSettingsItem[]) => {
    const res = await httpApi.post<CheckoutMapSettingsItem[]>(`/api/ecom/${ecomId}/checkout/setting`, items);
    return res.getData();
};
